module.exports = __webpack_public_path__ + "static/media/gif_Tipeee_step_3.7d3ef20b.gif";